import { useEffect, useState, useRef } from 'react'
import { useQuery } from 'react-query'
import { getResourceList } from '../../models/BaseModel'
import { ImageReplacementAnchor, InlineNavigation, Loading, LogoNavigation, DrawerNavigation, BlankErrorBoundary } from '@scrippsproduct/networks-ui-library'

import './../../scss/Header.scss'

export default function Header() {
    const [menuLinks, setMenuLinks] = useState([])
    const [logoItems, setLogoItems] = useState([])
    const {isLoading, isSuccess, isError, data} = useQuery(['header', {resourceName: 'header'}], getResourceList)
    const sentinelRef = useRef()

    useEffect(() => {
        if (isSuccess) {
            setMenuLinks(data.get('menuLinks'))
            setLogoItems(data.get('logoItems'))
        }
    }, [isError, isSuccess, data])

    useEffect(() => {
        if (!sentinelRef.current) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                // When sentinel is visible (at top), remove scrolled class
                // When sentinel is not visible (scrolled past), add scrolled class
                document.documentElement.classList.toggle('scrolled', !entry.isIntersecting);
            },
            { 
                threshold: 0,
                rootMargin: '0px 0px 0px 0px'
            }
        );

        observer.observe(sentinelRef.current);

        return () => {
            observer.disconnect();
            document.documentElement.classList.remove('scrolled');
        };
    }, []);
    
    return (<>
        {/* Sentinel element to detect scroll position */}
        <div ref={sentinelRef} className="scroll-sentinel" />
        <header>
            <content-constrainer class="desktop-nav">
                <ImageReplacementAnchor href={`/`} 
                    image={{
                        url: 'https://ewscripps-brightspot-lower.s3.amazonaws.com/b5/63/73d728894ffe9c98564d5db1019d/ion-herologo-white.png', 
                        width: 80, 
                        height: 51,
                        altText: 'ION Television logo, to the homepage',
                    }} 
                    height={3.5}
                    baselineAdjustment={0.6}
                    text=""
                />
                { (isLoading) && <Loading />}
                <header-menu-wrapper>
                    { (isSuccess && menuLinks.length > 0) && 
                        <BlankErrorBoundary>
                            <InlineNavigation 
                                links={menuLinks} 
                                classname="main-navigation" 
                                position='right'
                            />
                        </BlankErrorBoundary>
                    } 
                    { (isSuccess && logoItems.length > 0) && 
                        <LogoNavigation items={logoItems} />
                    }
                </header-menu-wrapper>
            </content-constrainer>
            <nav className="mobile-nav">
                <content-constrainer class="content-constrainer--no-border content-constrainer--no-padding">
                    <BlankErrorBoundary>
                        { (isSuccess && menuLinks.length > 0 && logoItems.length > 0) && 
                            <DrawerNavigation
                                links={[
                                    {
                                        type: 'internal-link',
                                        href: '/',
                                        label: 'Home',
                                    },
                                    ...menuLinks
                                ]} 
                                items={logoItems}
                                logo={{
                                    image: {
                                        url: 'https://ewscripps-brightspot-lower.s3.amazonaws.com/b5/63/73d728894ffe9c98564d5db1019d/ion-herologo-white.png', 
                                        width: 80, 
                                        height: 51,
                                        altText: 'ION Television logo, to the homepage',
                                    },
                                    href: process.env.REACT_APP_BASE_URL,
                                    height: 2.5,
                                    baselineAdjustment: 0
                                }}
                                classname="main-navigation"
                                clipPathStart="polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)"
                                clipPathEnd="polygon(0% 0%, 100% 0%, 100% 85%, 0% 100%)"
                                overlayAppendEl={document.querySelector('site-wrapper')}
                            /> 
                        }
                    </BlankErrorBoundary>
                </content-constrainer>
            </nav>
        </header>
    </>)
}
